var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky-image-wrapper"},[_c('v-img',{attrs:{"src":require('../assets/mountains_no_bg2.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }